import { MobXProviderContext } from "mobx-react";
import { useContext } from "react";
import { stores } from "../stores";

export const useStores = () => {
	return useContext<typeof stores>(MobXProviderContext as any);
}
